import moment from 'moment';
import Cookies from 'universal-cookie';

const formatTime = (date) => {
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;
  if (!date) return null;
  const d = moment.tz(date, timezone);
  const hh = String(d.get('hours')).padStart(2, '0');
  const mm = String(d.get('minutes')).padStart(2, '0');
  const ss = String(d.get('seconds')).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
};

const patchUpdateGiveawayItemRequest = ({ form, briefMainGiveawayId }) => {
  const payload = {
    briefMainGiveawayId,
    imagePath: form?.imagePath?.key,
    productName: form?.productName,
    totalStock: parseInt(form?.totalStock),
    rules: {
      minimumPurchaseAmount: form?.rules?.minimumPurchaseAmount ? parseInt(String(form?.rules?.minimumPurchaseAmount).replace(/\./g, '')) : 0,
      note: form?.rules?.note,
      type: form?.rules?.type?.value,
      requiredProducts:
        form?.rules?.type?.value !== 'MINIMUM_PURCHASE' || form?.rules?.withProductPurchase
          ? form?.rules?.requiredProducts?.map((product) => ({
              productName: product?.productName,
              imagePath: product?.isManual ? product?.imageKey : product?.imagePath,
              sku: product?.sku || '',
              isManual: Boolean(product?.isManual),
            }))
          : undefined,
    },
    sessions: form?.sessions?.map((session) => {
      return {
        id: session?.id,
        allocatedStock: parseInt(session?.allocatedStock),
        accountLivestreamId: session?.accountLivestreamId?.value,
        promotionDate: moment(session?.promotionDate).format('YYYY-MM-DD'),
        startTime: formatTime(session?.startTime),
        endTime: formatTime(session?.endTime),
      };
    }),
  };
  return payload;
};

export default patchUpdateGiveawayItemRequest;
